import api from './api';
import type { Booking, BookingHistoryEntry, BookingPaymentMethod, GroupBookingResult, GroupStatus, ManifestResponse, Paginated } from '../types/api';

export const paymentMethodLabel = (method: BookingPaymentMethod | undefined): string => {
  switch (method) {
    case 'cash':      return 'Cash';
    case 'stk':       return 'M-Pesa STK';
    case 'mpesa_sms': return 'M-Pesa Paybill';
    default:          return '—';
  }
};

export interface GroupBookingPayload {
  trip: number;
  seats: number[];
  boarding_stop_id: number;
  alighting_stop_id: number;
  passenger_name: string;
  passenger_phone: string;
  passenger_id_number?: string;
}

export async function createBookingGroup(payload: GroupBookingPayload): Promise<GroupBookingResult> {
  const { data } = await api.post<GroupBookingResult>('/bookings/group/', payload);
  return data;
}

export async function groupSendStk(groupId: number, phone: string): Promise<void> {
  await api.post(`/bookings/group/${groupId}/send_stk/`, { phone });
}

export async function groupMarkPaid(groupId: number): Promise<void> {
  await api.post(`/bookings/group/${groupId}/mark_paid/`);
}

export async function listBookings() {
  const { data } = await api.get<Paginated<Booking> | Booking[]>('/bookings/');
  return Array.isArray(data) ? data : data.results;
}

export async function createBooking(payload: {
  trip: number;
  seat: number;
  boarding_stop_id: number;
  alighting_stop_id: number;
  passenger_name: string;
  passenger_phone: string;
  passenger_id_number?: string;
}) {
  const { data } = await api.post<Booking>('/bookings/', payload);
  return data;
}

export async function markPaid(id: number) {
  await api.post(`/bookings/${id}/mark_paid/`);
}

export async function cancelBooking(id: number) {
  await api.post(`/bookings/${id}/cancel/`);
}

export async function refundBooking(id: number) {
  await api.post(`/bookings/${id}/refund/`);
}

export async function getManifest(tripId: number): Promise<ManifestResponse> {
  const { data } = await api.get<ManifestResponse>(`/trips/${tripId}/manifest/`);
  return data;
}

/** Merged change-log timeline for a booking (manifest viewers only). */
export async function getBookingHistory(bookingId: number): Promise<BookingHistoryEntry[]> {
  const { data } = await api.get<BookingHistoryEntry[]>(`/bookings/${bookingId}/history/`);
  return data;
}

export async function guestPay(groupId: number): Promise<void> {
  await api.post(`/bookings/group/${groupId}/pay/`);
}

export async function getGroupStatus(reference: string): Promise<GroupStatus> {
  const { data } = await api.get<GroupStatus>(`/bookings/group/${reference}/status/`);
  return data;
}
